<template>
  <div>
    <div class="d-aligncnter">
      <img src="@/assets/img/sportteam/plan.svg" class="title-img" />
      <span class="ml-8">运动队实时签到信息</span>
    </div>
    <div class="mt-16" @mouseenter="stopScroll" @mouseleave="startScroll">
      <table class="table t-table" cellspacing="0">
        <tr class="t-head" style="font-size: 16px">
          <td class="td-2"><div>学号</div></td>
          <td class="td-2"><div>姓名</div></td>
          <td class="td-1"><div>所属队伍</div></td>
          <td class="td-1"><div>签到时间</div></td>
        </tr>
      </table>
      <table
        class="table"
        cellspacing="0"
        :class="{ 'animated-top': animatedTop && this.sonData.length > 7 }"
      >
        <tr
          style="font-size: 16px"
          class="tr-line"
          v-for="(item, index) in sonData"
          :key="'signinList_' + index"
          :class="{ 'has-bg': index % 2 == 1 }"
        >
          <td class="td-2">
            <div>{{ item.stuNum }}</div>
          </td>
          <td class="td-2">
            <div>{{ item.stuName }}</div>
          </td>
          <td class="td-1">
            <div>{{ item.teamName }}</div>
          </td>
          <td class="td-1">
            <div>{{ item.date }}</div>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
export default {
  name: '',
  components: {},
  props: ['signinList'],
  watch: {
    signinList: {
      handler: function () {
        this.sonData = this.signinList
      },
      deep: true,
    },
  },
  created() {
    this.sonData = this.signinList
  },
  mounted() {
    this.timer = setInterval(() => {
      if (this.sonData.length > 7) {
        this.animatedTop = true
        setTimeout(() => {
          this.sonData.push(this.sonData[0])
          this.sonData.shift()
          this.animatedTop = false
          console.log('this.sonData,', this.sonData[0])
        }, 500)
      } else {
        this.stopScroll()
      }
    }, 2000)
  },
  data() {
    return {
      mySize: 5.208,
      currScale: 1,
      barOption: {},
      sonData: [],
      animatedTop: false,
      timer: null,
    }
  },
  methods: {
    stopScroll() {
      clearInterval(this.timer)
      this.timer = null
    },
    startScroll() {
      this.timer = setInterval(() => {
        if (this.sonData.length > 7) {
          this.animatedTop = true
          setTimeout(() => {
            this.sonData.push(this.sonData[0])
            this.sonData.shift()
            this.animatedTop = false
          }, 500)
        } else {
          this.stopScroll()
        }
      }, 2000)
    },
  },
}
</script>
<style lang="scss" scoped>
.t-head {
  width: 470px;
  height: 37px;
  //   background: linear-gradient(
  //     0deg,
  //     rgba(6, 88, 58, 0.0884779) -24.83%,
  //     #06583a 100%
  //   );
  background: #06583a;
}
// td {
//   padding: 0px 16px;
// }

.td-1 {
  width: 140px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

  div {
    width: 140px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    text-align: center;
  }
}
.td-2 {
  width: 95px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

  div {
    width: 95px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    text-align: center;
  }
}
.tr-line {
  font-size: 14px;
  width: 896px;
  height: 34px;
  cursor: pointer;
}

.has-bg {
  background: rgba(0, 122, 77, 0.1);
}
.mt-16 {
  margin-top: 16px;
}
.animated-top {
  transition: all 0.5s;
  margin-top: -34px;
}
.t-table {
  z-index: 9;
  position: sticky;
}
</style>
